/**
 * #1035 Osterbetreuung / Weihnachts- und/oder Neujahrsbetreuung am Kunden.
 *
 * Ab wann der rote Hinweis erscheint, die Frist und wann die Angabe wieder
 * entfernt wird, steht in der Administration. Das Backend rechnet den Hinweis
 * aus (customer.holidayCareMissing) und leert die Angaben am Stichtag
 * (automationholidaycare:reset).
 */
export const HOLIDAY_CARE_FIELDS = [
    { field: 'christmasCare', label: 'Weihnachts- und/oder Neujahrsbetreuung' },
    { field: 'easterCare', label: 'Osterbetreuung' },
];
